module.exports = __webpack_public_path__ + "static/golf-64831e52ec746fadeff6bcdd4d2bf796.jpg";